const packagingDtmMapper = require('./analytics/packaging-preference-analytics-mapper');
const { find, map } = require('lodash');

class PackagingPreferenceService {
    constructor(restangular, analytics) {
        this.api = restangular.one('Delivery');
        this.analytics = analytics;
    }

    getPackagingPreferenceOptions() {
        return this.api.one('PackagingPreferences').get().then((response) => {
            this.populatePackagingPreferenceDropdown(response);
        });
    }

    setPackagingPreferenceSession(preferenceId) {
        this.packagingPreferenceOptions = this.api.one('PackagingPreferences', preferenceId).post().then((response) => {
            this.populatePackagingPreferenceDropdown(response);
            this.selectedPackagingPreference = find(this.packagingPreferenceOptions, ['id', preferenceId]);
        });
    }

    populatePackagingPreferenceDropdown(source) {
        if (source) {
            // convert backend dto to frontend dropdown object
            this.packagingPreferenceOptions = map(source.PackagingPreferences, value => ({
                id: value.Id, code: value.Code, text: value.DisplayText, isSelected: value.IsSelected,
            }));
            // populate default dropdown selection from session
            this.selectedPackagingPreference = find(this.packagingPreferenceOptions, ['isSelected', true]);
        }
    }

    pushToAnalytics(data) {
        if (data) {
            this.analytics.push({
                data,
                dtmMapperFn: packagingDtmMapper,
            });
        }
    }
}

PackagingPreferenceService.$inject = ['Restangular', 'AnalyticsService'];

module.exports = PackagingPreferenceService;



// WEBPACK FOOTER //
// ./src/order/packaging/packaging-preference.service.js